__turbopack_context__.v({
  "container": "styles-module-scss-module__tKth9a__container",
  "date_card": "styles-module-scss-module__tKth9a__date_card",
  "date_card_badge": "styles-module-scss-module__tKth9a__date_card_badge",
  "date_card_badge_day": "styles-module-scss-module__tKth9a__date_card_badge_day",
  "date_card_badge_month": "styles-module-scss-module__tKth9a__date_card_badge_month",
  "date_card_details": "styles-module-scss-module__tKth9a__date_card_details",
  "date_card_info": "styles-module-scss-module__tKth9a__date_card_info",
  "date_card_name": "styles-module-scss-module__tKth9a__date_card_name",
  "date_card_name_hover": "styles-module-scss-module__tKth9a__date_card_name_hover",
  "dropdown": "styles-module-scss-module__tKth9a__dropdown",
  "dropdown-fade-in": "styles-module-scss-module__tKth9a__dropdown-fade-in",
  "dropdown_inner": "styles-module-scss-module__tKth9a__dropdown_inner",
  "modal": "styles-module-scss-module__tKth9a__modal",
  "modal_close": "styles-module-scss-module__tKth9a__modal_close",
  "modal_icon": "styles-module-scss-module__tKth9a__modal_icon",
  "modal_overlay": "styles-module-scss-module__tKth9a__modal_overlay",
  "modal_subtitle": "styles-module-scss-module__tKth9a__modal_subtitle",
  "modal_title": "styles-module-scss-module__tKth9a__modal_title",
  "option": "styles-module-scss-module__tKth9a__option",
  "provider_icon": "styles-module-scss-module__tKth9a__provider_icon",
  "trigger_button": "styles-module-scss-module__tKth9a__trigger_button",
});
